import React, { Component } from "react";
import ReactDOM from "react-dom";
import styles from "../styles/components/Dropdown.scss";
import { connect } from "react-redux";
import { hideDropdown, showDropdown } from "../redux/actions/general/dropdown";
import classNames from "classnames";
import ClickOutside from "react-click-outside";
import autobind from "autobind-decorator";

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdown_offset_y: 0,
      portal_position: null,
    };
  }

  @autobind
  _showDropdown(e) {
    e.stopPropagation();

    if (this.props.portal) {
      const trigger = e.currentTarget.getBoundingClientRect();

      this.setState(
        {
          dropdown_offset_y: 0,
          portal_position: {
            top: trigger.top + (this.props.top || 40),
            trigger_top: trigger.top,
            trigger_height: trigger.height,
            trigger_width: trigger.width,
            left: trigger.left + (this.props.left || 0),
            right: window.innerWidth - trigger.right + (this.props.right || 0),
          },
        },
        () => showDropdown(this.props.name),
      );

      return;
    }

    showDropdown(this.props.name);
  }

  @autobind
  _handleClickOutside() {
    if (this.props.closable !== false) {
      hideDropdown();
    }
  }

  @autobind
  _handleScroll() {
    if (
      this.props.closeOnScroll &&
      this.props.shown == this.props.name &&
      this.props.closable !== false
    ) {
      hideDropdown();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.shown != this.props.shown &&
      this.props.shown == this.props.name
    ) {
      this._handleDropdownOffset();
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this._handleScroll, true);
    window.addEventListener("resize", this._handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this._handleScroll, true);
    window.removeEventListener("resize", this._handleScroll);
  }

  _handleDropdownOffset() {
    const { dropdown_offset_y, portal_position } = this.state;

    const window_height = window.innerHeight;

    const dropdown_ref = this.refs.dropdown;

    if (
      this.props.shown == this.props.name &&
      dropdown_ref &&
      dropdown_ref.container
    ) {
      const dropdown = dropdown_ref.container.getBoundingClientRect();

      if (this.props.portal && portal_position) {
        const dropdown_gap = Math.max(
          (this.props.top || 40) - portal_position.trigger_height,
          0,
        );
        const dropdown_height = dropdown.height;
        const bottom_position =
          portal_position.trigger_top + (this.props.top || 40);
        const bottom_end_y = bottom_position + dropdown_height + 20;
        const top_position = Math.max(
          10,
          portal_position.trigger_top - dropdown_height - dropdown_gap,
        );

        this.setState({
          dropdown_offset_y: 0,
          portal_position: {
            ...portal_position,
            top:
              this.props.placement === "top" || bottom_end_y > window_height
                ? top_position
                : bottom_position,
          },
        });

        return;
      }

      const dropdown_height = dropdown.height + 20;
      const dropdown_start_y = dropdown.top - dropdown_offset_y;
      const dropdown_end_y = dropdown_start_y + dropdown_height;

      if (dropdown_end_y > window_height) {
        this.setState({
          dropdown_offset_y: window_height - dropdown_end_y,
        });
      } else {
        this.setState({
          dropdown_offset_y: 0,
        });
      }
    }
  }

  _dropdownStyle() {
    const { dropdown_offset_y, portal_position } = this.state;

    if (this.props.portal && portal_position) {
      return {
        position: "fixed",
        top: portal_position.top + dropdown_offset_y + "px",
        left: _.isNil(this.props.right)
          ? portal_position.left + "px"
          : undefined,
        right: _.isNil(this.props.right)
          ? undefined
          : portal_position.right + "px",
        width: this.props.matchTriggerWidth
          ? portal_position.trigger_width + "px"
          : undefined,
        zIndex: this.props.portalZIndex,
        marginTop: 0,
      };
    }

    return {
      top: dropdown_offset_y + "px",
      ..._.pick(this.props, ["left", "right", "bottom"]),
      marginTop: (this.props.top || 40) + "px",
    };
  }

  _dropdown() {
    return (
      <ClickOutside
        style={this._dropdownStyle()}
        onClickOutside={this._handleClickOutside}
        className={classNames(
          styles.dropdown,
          this.props.leftStyled && styles.leftStyledDropdown,
          this.props.dropdownClassName,
        )}
        ref="dropdown"
      >
        <div className={styles.header}>{this.props.header}</div>
        <div className={styles.content}>{this.props.content}</div>
      </ClickOutside>
    );
  }

  render() {
    const { readOnly, doubleClick } = this.props;

    return (
      <div
        className={classNames(
          styles.wrapper,
          this.props.leftStyled && styles.leftStyled,
          this.props.wrapperClassName,
        )}
      >
        <div
          className={classNames(!readOnly && styles.clickable)}
          onClick={(e) => !readOnly && !doubleClick && this._showDropdown(e)}
          onDoubleClick={(e) =>
            !readOnly && doubleClick && this._showDropdown(e)
          }
        >
          {this.props.children}
        </div>
        {this.props.shown == this.props.name &&
          (this.props.portal
            ? ReactDOM.createPortal(this._dropdown(), document.body)
            : this._dropdown())}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.general.dropdown,
  };
}

export default connect(mapStateToProps, null)(Dropdown);
